export enum CustomPropertyAttributeType {
  STRING = 'string',
  DATE = 'date',
  INTEGER = 'integer',
  NUMBER = 'number',
}

export interface CustomPropertyAttributeJson {
  slug: string;
  label: string;
  type: CustomPropertyAttributeType;
  order: number;
  required: boolean;
  active: boolean;
}

export interface CustomPropertyAttribute extends CustomPropertyAttributeJson {
  propertyTypeId: number;
  isTargetPropertyType: boolean;
}
